import React from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  Spinner,
} from "reactstrap"
import PrimaryButton from "newcomponents/primary-button"
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined"

const FetchModal = ({
  isOpen,
  toggle,
  mode = "light",
  title = "Fetch Data",
  label = "Enter URL",
  placeholder = "Enter a valid URL",
  value,
  onChange,
  fetchedData,
  loading = false,
  onFetch,
  onConfirm,
  confirmDisabled,
  confirmText = "Confirm",
  fetchText = "Fetch",
  icon: IconComponent = CloudDownloadOutlinedIcon,
  iconColor,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      style={{
        maxWidth: "500px",
      }}
    >
      <div
        style={{
          backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
          borderRadius: "12px",
          padding: "0",
        }}
      >
        {/* Header */}
        <ModalHeader
          toggle={toggle}
          style={{
            backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
            color: mode === "dark" ? "#fff" : "#000",
            fontWeight: "600",
            fontSize: "18px",
            borderBottom:
              mode === "dark" ? "1px solid #374151" : "1px solid #e5e7eb",
            paddingBottom: "16px",
          }}
        >
          {title}
        </ModalHeader>

        {/* Body */}
        <ModalBody
          style={{
            backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
            padding: "30px 40px",
          }}
        >
          <div
            style={{
              width: "120px",
              height: "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px",
            }}
          >
            <IconComponent
              style={{
                fontSize: "70px",
                color:
                  iconColor || (mode === "dark" ? "#2990DF" : "#2990DF"),
              }}
            />
          </div>

          <FormGroup>
            <Label
              for="fetchInput"
              style={{
                color: mode === "dark" ? "#fff" : "#6c757d",
                fontWeight: "500",
              }}
            >
              {label}
            </Label>
            <Input
              id="fetchInput"
              type="url"
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              style={{
                backgroundColor: mode === "dark" ? "#111827" : "#fff",
                color: mode === "dark" ? "#fff" : "#000",
                border:
                  mode === "dark" ? "1px solid #374151" : "1px solid #ced4da",
              }}
            />
          </FormGroup>

          {fetchedData && (
            <Card
              className="mt-4"
              style={{
                backgroundColor: mode === "dark" ? "#111827" : "#f9fafb",
                borderRadius: "8px",
                border:
                  mode === "dark" ? "1px solid #374151" : "1px solid #e5e7eb",
              }}
            >
              <CardBody>
                <h5
                  style={{
                    color: "#2990DF",
                    marginBottom: "6px",
                  }}
                >
                  {fetchedData.facility}
                </h5>
                <p
                  style={{
                    color: mode === "dark" ? "#9ca3af" : "#666",
                    fontSize: "13px",
                    marginBottom: "0",
                  }}
                >
                  <strong>Address:</strong> {fetchedData.address}
                </p>
              </CardBody>
            </Card>
          )}
        </ModalBody>

        {/* Footer */}
        <ModalFooter
          style={{
            backgroundColor: mode === "dark" ? "#1f2937" : "#fff",
            justifyContent: "center",
            gap: "12px",
            borderTop:
              mode === "dark" ? "1px solid #374151" : "1px solid #e5e7eb",
          }}
        >
          {/* Fetch Button */}
          <PrimaryButton
            onClick={onFetch}
            disabled={loading}
            style={{
              backgroundColor: "#2990DF",
              color: "#fff",
              fontSize: "14px",
              fontWeight: "500",
              border: "none",
              width: "166px",
              height: "46px",
              minWidth: "120px",
              borderRadius: "5px",
            }}
          >
            {loading ? <Spinner size="sm" /> : fetchText}
          </PrimaryButton>

          {/* Confirm Button */}
          <PrimaryButton
            onClick={onConfirm}
            disabled={confirmDisabled || loading}
            style={{
              backgroundColor: "#10B981",
              color: "#fff",
              fontSize: "14px",
              fontWeight: "500",
              border: "none",
              width: "166px",
              height: "46px",
              minWidth: "120px",
              borderRadius: "5px",
            }}
          >
            {loading ? <Spinner size="sm" /> : confirmText}
          </PrimaryButton>
        </ModalFooter>
      </div>
    </Modal>
  )
}

export default FetchModal
